export type CustomerPayment = {
  id: string;

  status: PaymentScheduleStatus;
  dueDate: string;
  amount: string;
  paidSoFar?: string;
  currency?: {
    id: string;
    code: string;
  };
  bookingAmount: string;
  booking: {
    id: string;
    bookingDateFrom?: string;
    bookingDateTo?: string;
    yacht: {
      id: string;
      name: string;
      operator: {
        id: string;
        name: string;
        transferDetails: string;
      };
    };
    currency: {
      id: string;
      code: string;
    };
  };
};

export type CustomerType = {
  id?: string;
  email: string;
  firstName: string;
  lastName: string;
  mobile: string;
  additionalEmails: {
    id: string;
    email: string;
  }[];
  hubspotAddress: {
    streetAddress: string;
    postalCode: string;
    city: string;
    stateRegion: string,
    countryRegion: string;
  }
};

export type OperatorPayment = {
  id: string;

  status: PaymentScheduleStatus;
  dueDate: string;
  amount: string;
  paidSoFar?: string;
  currency?: {
    id: string;
    code: string;
  };
  booking: {
    id: string;
    bookingDateFrom?: string;
    bookingDateTo?: string;
    yacht: {
      id: string;
      name: string;
      operator: {
        id: string;
        name: string;
        transferDetails: {
          recipientName: string;
          accountNumber: string;
        };
      };
    };
    currency: {
      id: string;
      code: string;
    };
  };
};

export enum PayerType {
  CUSTOMER = "Customer",
  OPERATOR = "Operator",
}

export enum PaymentScheduleStatus {
  WAITING = "WAITING",
  PARTIALLY_PAID = "PARTIALLY_PAID",
  OVERDUE = "OVERDUE",
  FULLY_PAID = "FULLY_PAID",
}

export const mapPaymentScheduleStatusEnumToText = (status: PaymentScheduleStatus) => {
  switch (status) {
    case PaymentScheduleStatus.OVERDUE:
      return "Overdue";
    case PaymentScheduleStatus.FULLY_PAID:
      return "Fully paid";
    case PaymentScheduleStatus.PARTIALLY_PAID:
      return "Partially paid";
    case PaymentScheduleStatus.WAITING:
      return "Waiting";
    default:
      return "";
  }
};
